import angular from 'angular'

angular
  .module('admin.genres.channel_orders', [])
  .controller('GenresChannelsOrdersCtrl', GenresChannelsOrdersCtrl)

/** @ngInject */
function GenresChannelsOrdersCtrl($stateParams, EventService, GenresService) {
  var vm = this

  vm.items = []
  vm.channels = []
  vm.id = $stateParams.id

  function load() {
    GenresService.listGenreOrders(vm.id).then(function (result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  load()

  EventService.listChannels().then(function (result) {
    vm.channels = result.results
  })

  vm.add = function (item) {
    $('#myModalAdd').modal('show')
    vm.app = {
      id: 0,
      n: 0,
      'id-ch': null,
    }
  }

  vm.edit = function (item) {
    $('#myModalAdd').modal('show')
    vm.app = item
  }

  vm.set = function () {
    vm.app.n = parseInt(vm.app.n)
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          GenresService.setOrder(vm.id, vm.app).then(
            function () {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.unset = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          GenresService.unsetOrder(vm.id, {
            'id-ch': item['id-ch'],
            n: item.n,
          }).then(
            function () {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }
}
